module.exports = __webpack_public_path__ + "img/qatar.71128331.svg";